//import liraries
import React, { useEffect, useState } from "react";
import { Dimensions} from "react-native";

import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize, } from "rn-responsive-styles";


const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView =
  Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;



// define your styles
const useStyles = CreateResponsiveStyle(
  {
    mainContainer: {
      width: "100%",
      height: 440,
      backgroundColor: "#ffffff",
      borderRadius: 15,
      marginLeft: 20,
      marginTop: 20,
    },
    container: {
      marginTop: "2%",
      flexDirection: "row",
      paddingRight: 20,
      paddingHorizontal: isSmallDevice || isTabView ? null : 40,
      marginLeft: isSmallDevice || isTabView ? null : 5,
    },
    subContainer: {
      flexDirection: "row",
      marginLeft: "7%",
    },
    backIcon: {
      height: 19,
      width: 19,
      resizeMode: "center",
      opacity: 0.8,
    },
    textStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#999999",
      marginLeft: 10,
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
    },
    textOptions: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 18,
      letterSpacing: 0,
      textAlign: "left",
      color: "#5f5f5f",
    },
    chooseTransferView: {
      marginVertical: 20,
      marginLeft: 70,
    },
    chooseTransferType: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 18,
      letterSpacing: 0,
      textAlign: "left",
      color: "#5f5f5f",
    },
    subText: {
      marginTop: 6,
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: "300",
      fontStyle: "normal",
      lineHeight: 19,
      letterSpacing: 0.36,
      textAlign: "left",
      color: "#757575",
    },

    selectionContainerStyle: {
      flexDirection: "row",
      alignItems: "center",
      marginLeft: 75,
    },

    radiobuttonOutSideStyle: {
      width: 18,
      height: 18,
      borderRadius: 10,
      borderColor: "#9d1d27",
      borderWidth: 2,
      alignItems: "center",
      justifyContent: "center",
    },
    radioButtonInsideStyle: {
      height: 10,
      width: 10,
      borderRadius: 7,
      backgroundColor: "#9d1d27",
    },
    chooseOptionStyle: {
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 17,
      letterSpacing: 0,
      textAlign: "left",
      color: "#797673",
    },
    boxContainer: {
      width: 450,
      height: 152,
      flexDirection: "row",
      borderWidth: 1,
      borderColor: "#ff6e6e",
      borderRadius: 10,
      borderStyle: "solid",
      marginVertical: 17,
    },
    box: {
      width: 149.3,
      height: 150,
      borderRadius: 10,
      justifyContent: "center",
      paddingHorizontal: 10
    },
    boxHeading: {
      width: 90,
      fontSize: 12,
      fontWeight: "600",
      color: "#bd2d37",
      marginLeft: 10,
    },
    boxHeadingText: {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: "600",
      fontStyle: "normal",
      lineHeight: 16,
      letterSpacing: 0.24,
      textAlign: "left",
      color: "#bd2d37",
    },
    boxText: {
      width: 122,
      opacity: 0.6,
      fontFamily: "Inter",
      fontSize: 10,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 14,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
      paddingLeft: 5,
    },
    radioText: {
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 23,
      letterSpacing: 0,
      textAlign: "left",
      color: "#66625f",
      marginVertical: 7,
      width: 100,
      marginLeft: 10,
    },
    customButton: {
      width: 218,
      height: 37,
      marginLeft: 70,
      marginTop: 10,
    },

    quickLinksView: {
      paddingTop: 0,
      paddingBottom: 20
    },
  },
  {
    [DEVICE_SIZES.SM]: {
      mainContainer: {
        width: "100%",
        height: 760,
        marginBottom: 50,
        paddingBottom: 50,
      },
      container: {
        flexDirection: "row",
        marginRight: 10,
        paddingTop: 10,
      },
      subContainer: {
        flexDirection: "column",
      },
      chooseTransferView: {
        marginVertical: 20,
        marginLeft: 5,
      },
      quickLinksView: {
        paddingTop: 30,
      },
      selectionContainerStyle: {
        flexDirection: "row",
        marginLeft: 10,
      },
      customButton: {
        width: 193.1,
        height: 35.1,
        marginLeft: 70,
        marginTop: "5%",
        marginLeft: 220,
      },
    },

    [DEVICE_SIZES.MD]: {
      mainContainer: {
        flexDirection: "column",
        width: "100%",
        height: 760,
      },
      boxContainer: {
        width: 460,
      },
      container: {
        flexDirection: "row",
        marginRight: 10,
        paddingTop: 10,
      },
      subContainer: {
        flexDirection: "column",
      },

      chooseTransferView: {
        marginVertical: 20,
        marginLeft: 10,
      },
      quickLinksView: {
        paddingTop: 30,
      },
      selectionContainerStyle: {
        flexDirection: "row",
        marginLeft: 10,
      },
      customButton: {
        width: 193.1,
        height: 35.1,
        marginLeft: 70,
        marginTop: "5%",
        marginLeft: 220,
      },
    },
    [DEVICE_SIZES.XS]: {
      mainContainer: {
        width: "100%",
        height: 760,
        marginBottom: 50,
        paddingBottom: 50,
        marginLeft: 0
      },
      container: {
        flexDirection: "row",
        marginLeft: 20,
        paddingTop: 10,
      },
      subContainer: {
        flexDirection: "column",
        marginBottom: 10,
      },
      chooseTransferView: {
        marginVertical: 20,
        marginLeft: 5,
      },
      quickLinksView: {
        paddingTop: 30,
      },
      selectionContainerStyle: {
        flexDirection: "row",
        marginLeft: 10,
      },
      customButton: {
        width: 193.1,
        height: 35.1,
        alignSelf: "flex-end",
        marginRight: 50,
        marginTop: "5%",
      },
      boxContainer: {
        width: 254,
        height: 239,
        flexDirection: "column",
        marginVertical: 5,
      },
      box: {
        height: 80,
        width: "100%",
      },
      boxText: {
        width: "100%",
      },
    },
  }
);

//make this component available to the app
export default useStyles;
